import { ROBOT_CREATE_SUCCESS } from './createRobotRequest';

export const createRobotSuccess = (id) => ({
  type: ROBOT_CREATE_SUCCESS,
  payload: {
    id,
  },
})
